//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import St21Cn2061ReportDate from '@views/decision/report/St21Cn2061ReportDate.vue';
import St21Cn2061ReportMonth from '@views/decision/report/St21Cn2061ReportMonth.vue';
import St21Cn2061ReportYear from '@views/decision/report/St21Cn2061ReportYear.vue';
import St21Cn2061ReportCustom from '@views/decision/report/St21Cn2061ReportCustom.vue';
import cn2011 from '@views/online/data/cn2011.vue';
export default {
  name: 'realTimeData',
  data: function data() {
    return {
      reportType: '1'
    };
  },
  components: {
    cn2011: cn2011,
    St21Cn2061ReportCustom: St21Cn2061ReportCustom,
    St21Cn2061ReportYear: St21Cn2061ReportYear,
    St21Cn2061ReportMonth: St21Cn2061ReportMonth,
    St21Cn2061ReportDate: St21Cn2061ReportDate
  },
  props: ['siteId', 'selectType', 'showSiteTree'],
  created: function created() {},
  watch: {},
  methods: {}
};